import { Box } from '@mui/material';
import React from 'react';
import PortfolioMenuItem from './PortfolioMenuItem';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { setTab } from '../../store/actions/portfolioDetails';
import { useTranslation } from 'react-i18next';

const PortfolioMenu: React.FC = () => {
    const tab = useAppSelector(state => state.portfolioDetails.tab);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const onItemClick = (index: number): void => {
        dispatch(setTab(index));
    }

    return <Box display={"flex"} gap={"17px"} justifyContent={"stretch"} width={"100%"}>
        <PortfolioMenuItem title={t('PortfolioDetailsTab1')} onClick={() => onItemClick(0)} isActive={tab === 0} />
        <PortfolioMenuItem title={t('PortfolioDetailsTab2')} onClick={() => onItemClick(1)} isActive={tab === 1} />
        <PortfolioMenuItem title={t('PortfolioDetailsTab3')} onClick={() => onItemClick(2)} isActive={tab === 2} />
        <PortfolioMenuItem title={t('PortfolioDetailsTab4')} onClick={() => onItemClick(3)} isActive={tab === 3} />
        <PortfolioMenuItem title={t('PortfolioDetailsTab5')} onClick={() => onItemClick(4)} isActive={tab === 4} />
        <PortfolioMenuItem title={t('PortfolioDetailsTab6')} onClick={() => onItemClick(5)} isActive={tab === 5} />
    </Box>
}

export default PortfolioMenu;